import { cn } from "@/zapi-frontend/shared/lib/utils";
import { AppButton } from "@libs/zapi-ui/custom";
import { CheckCircle2Icon } from "lucide-react";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { hasEditAccess } from "@/zapi-frontend/shared/utils/permissions";

export function ToggleReviewed({ onChange, isReviewed }: { onChange: () => void; isReviewed: boolean }) {
  const { role, accessMode } = useMeStore();
  const hasEdit = hasEditAccess(role, accessMode);
  if (!hasEdit) return null;
  return (
    <AppButton
      data-testid="claims-reviewed-toggle"
      appearance="outlined"
      size="sm"
      onClick={onChange}
      className={cn(
        isReviewed
          ? "border-innoveraGreen-700 text-innoveraGreen-700"
          : "bg-white text-innoveraZinc-700 border-innoveraZinc-150",
        "ml-auto"
      )}
      endAdornment={
        <CheckCircle2Icon
          className={cn("h-3 w-3", isReviewed ? "stroke-innoveraGreen-700" : "stroke-innoveraZinc-700")}
        />
      }
    >
      Reviewed
    </AppButton>
  );
}
